import { connect } from 'react-redux'
import { reduxForm } from 'redux-form/immutable'
import { createStructuredSelector } from 'reselect'
import { PROFILE_FORM_NAME } from 'app/constants/profile'

import OutOfOffice from 'app/domains/routes/Profile/OutOfOffice'
import { getIdentityUserData } from 'store/entities/identity/selectors'
import { saveProfile } from 'store/entities/identity/actions'

const mapStateToProps = createStructuredSelector({
  initialValues: getIdentityUserData,
})

const mapDispatchToProps = {
  onSubmit: saveProfile,
}

const formProps = {
  form: PROFILE_FORM_NAME,
  destroyOnUnmount: false,
}

export default connect(mapStateToProps, mapDispatchToProps)(reduxForm(formProps)(OutOfOffice))
